import styled from 'styled-components';
import { Checkbox, FormHelperText } from '@mui/material';

import { ReactComponent as PopoverIcon } from '../../assets/icons/popover-icon.svg';
import { ReactComponent as FolderIconSvg } from '../../../assets/icons/folder-icon.svg';
import colors from '../../styles/colors';
import Button from '../Button/Button';
import Tag from '../Tag';

const Container = styled.div`
  display: flex;
  gap: 10px;
  height: auto;
  width: 100%;
  padding: 10px;
  flex-direction: row;
  flex-shrink: 0;
  background-color: ${colors.base.secondary2};
  align-content: center;
  flex-wrap: wrap;
`;

const ActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  /*
    Fill the space between the client name and the end actions, and let the action
    pills wrap onto the next line when the header is narrow (rather than scrolling),
    keeping the end actions (smart-context + overflow menu) steady on the top row.
  */
  flex: 1 1 auto;
  min-width: 0;
  flex-wrap: wrap;
  gap: 5px;

  & > * {
    flex: 0 0 auto;
  }
`;

const BackButton = styled(Button)`
  width: 15px;
  border: none;
  outline: none;
  padding: 0;
  background-color: transparent;
`;

const StyledBackIcon = styled.img`
  cursor: pointer;
  width: 15px;
  height: 18px;
`;

const TextContainer = styled.div`
  display: flex;
  overflow: hidden;
  align-items: center;
  height: 36px;
  font-size: 20px;
  font-weight: 600;
  text-wrap: nowrap;
  padding: 0;
  font-family: Arial, sans-serif;
  color: ${colors.base.alpha};
  justify-content: center;
  width: ${({ $width }) => (!$width ? 'auto' : `${$width}%`)};
`;

const StyledLink = styled.div`
  cursor: pointer;
  width: 100%;
  justify-content: left;
  font-size: 16px;
`;

const IconContainer = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
`;

const StyledChannelPopoverIcon = styled(PopoverIcon)`
  height: 30px;
  width: 30px;
  padding: 5px 0;
  > path {
    stroke: ${colors.base.secondary3};
  }
`;

const StyledTag = styled(Tag)`
  margin: auto;
  margin-left: 0;
`;

const SmartContextButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 18px;
  display: flex;
  align-items: center;
  & > svg {
    color: ${colors.base.alpha};
  }
`;

// Mirrors ThreadIndicator's pill, the affordance already used for thread counts on a root message.
/* `$muted` is the nothing-unread state: the inbox stays reachable without claiming attention. */
const ThreadNoticePill = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border: none;
  border-radius: 12px;
  background: ${({ $muted }) => ($muted ? colors.shades.gamma4 : colors.shades.secondary5)};
  color: ${({ $muted }) => ($muted ? colors.shades.gamma10 : colors.shades.secondary1)};
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: ${colors.shades.secondary7};
  }
`;

const EndActions = styled.div`
  margin-left: auto;
  display: flex;
  gap: 10px;
  align-items: center;
  /* Stay pinned to the top-right while the action pills wrap below. */
  flex-shrink: 0;
  align-self: flex-start;
`;

const SilenceToggleContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

const StyledCheckbox = styled(Checkbox)`
  && {
    color: white;
  }
  &&.Mui-checked {
    color: white;
  }
  &&.Mui-disabled {
    color: rgba(255, 255, 255, 0.3);
  }
`;

const StyledFormHelperText = styled(FormHelperText)`
  && {
    color: white;
  }
`;

const StyledFolderIcon = styled(FolderIconSvg)`
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

export {
  Container,
  ActionButtonsContainer,
  TextContainer,
  StyledLink,
  BackButton,
  StyledBackIcon,
  IconContainer,
  StyledChannelPopoverIcon,
  StyledTag,
  SmartContextButton,
  EndActions,
  ThreadNoticePill,
  SilenceToggleContainer,
  StyledCheckbox,
  StyledFormHelperText,
  StyledFolderIcon,
};
